import { css } from 'emotion';
import getFontStyles from '../../../../lib/styles/getFontStyles';
import getLineClampStyles from '../../../../lib/styles/getLineClampStyles';
import {
  LINES_ALLOWED,
  LINE_HEIGHT,
} from '../../../../lib/styles/dynamicStyleConstants';
import getButtonStyles from '../../../../lib/styles/getButtonStyles';

import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

import {
  ButtonStyle,
  ISettingsColors,
  ISettingsFonts,
} from '@wix/podcasts-common/dist/settings';

interface IGetStylesArgs {
  colors: ISettingsColors['episode'];
  fonts: ISettingsFonts['episode'];
  deviceType: TPADeviceType;
  buttonStyle: ButtonStyle;
}

export default function getStyles({
  colors,
  fonts,
  deviceType,
  buttonStyle,
}: IGetStylesArgs) {
  return {
    headerWrapper: css({
      backgroundColor: colors.headerBackgroundColor,
    }),
    episodeTitle: css({
      color: colors.headerTitleColor,
      ...getFontStyles(fonts.headerTitleFont, {
        lineHeight: LINE_HEIGHT.TITLE,
      }),
      ...{
        [TPADeviceType.MOBILE]: {
          fontSize: 22,
        },
      }[deviceType],
      ...getLineClampStyles(
        deviceType === TPADeviceType.MOBILE
          ? { size: 22 }
          : fonts.headerTitleFont,
        LINE_HEIGHT.TITLE,
        LINES_ALLOWED.EPISODE_HEADER_EPISODE_TITLE,
      ),
    }),
    podcastTitle: css({
      color: colors.headerSubtitleColor,
      ...getFontStyles(fonts.headerSubtitleFont, {
        lineHeight: LINE_HEIGHT.EPISODE_PAGE_TEXT,
      }),
      ...{
        [TPADeviceType.MOBILE]: {
          fontSize: 14,
        },
      }[deviceType],
      ...getLineClampStyles(
        deviceType === TPADeviceType.MOBILE
          ? { size: 14 }
          : fonts.headerSubtitleFont,
        LINE_HEIGHT.EPISODE_PAGE_TEXT,
        LINES_ALLOWED.EPISODE_HEADER_PODCAST_TITLE,
      ),
    }),
    button: css({
      ...getButtonStyles({
        buttonStyle,
        buttonColor: colors.headerButtonColor,
        buttonTextColor: colors.headerButtonTextColor,
        emptyButtonHoverTextColor: colors.headerBackgroundColor,
      }),
    }),
  };
}
